import React from "react"
import { CaretLeftOutlined } from "@ant-design/icons"
import { useNavigate } from "react-router"
import { useDispatch } from "react-redux"
import { HOME_PAGE } from "../../../core/constants"
import { languages } from "../../../lib/languages"
import style from "./PreviousButton.module.scss"
import { LOGOUT } from "../../../services/client/constants"
interface PreviousProps {
  onClick?: () => void
  text?: string
  reset?: boolean
  to?: string
}

const PreviousButton: React.FC<PreviousProps> = ({
  onClick,
  text,
  to,
  reset = false,
}) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const click = () => {
    if (onClick) {
      onClick()
    }
    if (to) {
      navigate(to)
    } else if (reset) {
      dispatch({ type: LOGOUT })
      navigate(HOME_PAGE)
    } else {
      !onClick && navigate(-1)
    }
  }
  return (
    <span className={style.Previous} onClick={click}>
      <CaretLeftOutlined />
      {text || languages.previous}
    </span>
  )
}

export default PreviousButton
